import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-template-modal',
  templateUrl: './template-modal.component.html',
  styleUrls: ['./template-modal.component.scss']
})
export class TemplateModalComponent {
  constructor(public bsModalRef: BsModalRef, public router: Router) {}

  onCloseModal(){
    this.bsModalRef.hide()
    this.router.navigate(['/vam/rating/exterior']);
  }
}
